import {
    CheckboxGroupInput,
    CheckboxGroupInputBaseProps,
} from "@impero-com/common/components/form/fields/checkboxGroupInput";
import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import type { CheckboxValueType } from "antd/es/checkbox/Group";
import { FieldValues, useController } from "react-hook-form";

export interface RHFCheckboxGroupInputProps<
    TFieldsValues extends FieldValues,
    T,
>
    extends
        CheckboxGroupInputBaseProps<T>,
        BaseRHFWidgetProps<TFieldsValues, T[]> {}

/**
 * Basic form component based on ant design's Checkbox.Group
 */
export const RHFCheckboxGroupInput = <
    TFieldsValues extends FieldValues,
    T extends CheckboxValueType,
>({
    name,
    control,
    label,
    options,
    disabled,
    columns,
    direction,
}: RHFCheckboxGroupInputProps<TFieldsValues, T>) => {
    const { field, fieldState } = useController({ name, control, disabled });

    return (
        <CheckboxGroupInput
            value={field.value}
            error={fieldState.error?.message}
            onChange={field.onChange}
            options={options}
            disabled={disabled}
            columns={columns}
            direction={direction}
            label={label}
            fieldRef={field.ref}
            onBlur={field.onBlur}
        />
    );
};
